import styled from "styled-components";
import Color from "../assets/Colors";
import {Link} from "react-router-dom";

export const ResetButton = styled.button`
   outline: none;
   border: none;
   cursor: pointer;
   background: transparent;
`;

const Button = styled.button`
   padding: ${(props) => props.padding || "0.8em 3.2em"};
   outline: none;
   border: none;
   background-color: ${(props) => props.back || "transparent"};
   border: 2px solid ${(props) => props.color || Color.primary};
   color: ${(props) => props.color || Color.primary};
   font-size: ${(props) => props.size || "1em"};
   display: block;
   font-weight: 200;
`;

export default Button;

export const ButtonLink = styled(Link)`
   width: 100%;
   display block;
   background: transparent;
   border: none;
   outline: none;
   border: 1px solid ${Color.primary};
   color: ${Color.primary};
   text-transform: uppercase;
   font-weight: 200;
   text-align: center;
   padding: 1.3em 0;
   cursor: pointer; 
   margin-top: 1.5em;
   font-family: Montserrat;
   
   @media screen and (max-width: 1600px) {
      padding: 0.9em 0;
   }
`;
